import { toolsSubMenus } from '../../publicCatalogDropdownConstants';
import UILoadingDots from 'UIComponents/loading/UILoadingDots';
import TopLevelMenuContent from './TopLevelMenuContent';
import SubMenuContent from './SubMenuContent';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const getFilterNameFromSubMenu = subMenuName => {
  return toolsSubMenus.includes(subMenuName) ? 'tools' : 'cat';
};
const MenuContent = ({
  filtersLoading,
  filtersError,
  filtersData,
  isSubMenuOpen,
  activeSubMenu
}) => {
  if (filtersLoading) {
    return /*#__PURE__*/_jsx(UILoadingDots, {
      "data-test-id": "mobile-categories-menu-loading"
    });
  }
  if (filtersError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "CATALOG_FILTERS_LOAD_FAILURE",
      children: /*#__PURE__*/_jsx(UIErrorMessage, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.catalogPage.filters.filtersLoadErrorDescription"
        })
      })
    });
  }
  if (filtersData && !isSubMenuOpen) {
    return /*#__PURE__*/_jsx(TopLevelMenuContent, {
      filtersData: filtersData
    });
  }
  if (filtersData && isSubMenuOpen) {
    return /*#__PURE__*/_jsx(SubMenuContent, {
      filterName: getFilterNameFromSubMenu(activeSubMenu),
      filtersData: filtersData,
      subMenuName: activeSubMenu
    });
  }
  return null;
};
export default MenuContent;